import { useQuery } from '@apollo/client';
import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { useState } from 'react';
import { gql } from '@/__generated__';
import {
  applyPointsContainer,
  applyPointsInfo,
  applyPointsLabel,
  applyPointsValue,
  applyPointsApplied,
} from './apply-learning-points.css';

const BALANCE_QUERY = gql(`
  query LearningPointsBalance {
    learningProgress {
      availablePoints
    }
  }
`);

export const ApplyLearningPoints = () => {
  const { data } = useQuery(BALANCE_QUERY);
  const [applied, setApplied] = useState(false);

  const points = data?.learningProgress?.availablePoints ?? 0;

  if (points <= 0) return null;

  const dollarValue = (points / 100).toFixed(2);

  return (
    <div className={applyPointsContainer}>
      <div className={applyPointsInfo}>
        <span className={applyPointsLabel}>Learning Center Points</span>
        <span className={applyPointsValue}>
          {points.toLocaleString()} pts (${dollarValue})
        </span>
      </div>
      {applied ? (
        <>
          <input type="hidden" name="redeemPoints" value={points} />
          <span className={applyPointsApplied}>Applied</span>
        </>
      ) : (
        <Button size="small" variant="outline" onClick={() => setApplied(true)}>
          Apply
        </Button>
      )}
    </div>
  );
};
